import { Button, Tooltip } from '@mui/material';
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import { useLocalization } from '@ui-framework/index';

function ShowHideWidgetsButton({ onClick, disabled = false, sx }) {
  const { formatMessage } = useLocalization();
  const label = formatMessage({
    id: 'SHOW_HIDE_WIDGETS_TITLE',
    defaultMessage: 'Choose widgets',
  });

  const button = (
    <Button
      aria-label={label}
      onClick={onClick}
      size="small"
      variant="outlined"
      disabled={disabled}
      sx={{ minWidth: 'auto', px: 1, ...sx }}>
      <DashboardCustomizeIcon />
    </Button>
  );

  return (
    <Tooltip title={label}>
      <span>{button}</span>
    </Tooltip>
  );
}

export default ShowHideWidgetsButton;
